<template>
    <div class="container">
        <div class="container-header">
            <img src="../assets/images/laidan_logo.png"
                 alt="">
            <a href="javascript:void(0)"
               @click="downloadHandle">{{ $t('clickCheck') }}</a>
        </div>
        <div class="container-main">
            <div class="card"
                 v-if="lotteryResult === 100">
                <div class="picture">
                    <img class="succeed"
                         src="../assets/images/code_error.png"
                         alt="">
                </div>
                <div class="desc">
                    <p class="desc-title">{{ $t('lottoErrorHint') }}</p>
                    <p class="desc-text">{{count}}s{{ $t('skipPlatLotto') }}</p>
                </div>
            </div>
            <div class="card"
                 v-else-if="lotteryResult === 101">
                <div class="picture">
                    <img class="succeed"
                         src="../assets/images/no_lottery.png"
                         alt="">
                </div>
                <div class="desc">
                    <p class="desc-title">{{ $t('lottoNoloHint') }}</p>
                    <p class="desc-text">{{count}}s{{ $t('skipPlatLotto') }}</p>
                </div>
            </div>
            <div class="card"
                 v-else-if="lotteryResult === 102">
                <div class="picture">
                    <img class="succeed"
                         src="../assets/images/nowinning.png"
                         alt="">
                </div>
                <div class="desc">
                    <p class="desc-title">{{ $t('lottoNowiHint') }}</p>
                    <p class="desc-title">{{ $t('partPlatLotto') }}</p>
                    <p class="desc-text">{{count}}s{{ $t('skipPlatLotto') }}</p>
                </div>
            </div>
            <div class="card"
                 v-else-if="lotteryResult === 103">
                <div class="picture">
                    <img class="succeed"
                         src="../assets/images/winning.png"
                         alt="">
                </div>
                <div class="desc">
                    <p class="desc-title">{{ $t('lottoWinnHint') }}</p>
                    <p class="desc-text">{{count}}s{{ $t('skipPrize') }}</p>
                </div>
            </div>
            <div class="card"
                 v-else-if="lotteryResult === 104">
                <div class="picture">
                    <img class="fail"
                         src="../assets/images/used.png"
                         alt="">
                </div>
                <div class="desc">
                    <p class="desc-title">{{ $t('lottoUsedHint') }}</p>
                    <p class="desc-text">{{count}}s{{ $t('skipPlatLotto') }}</p>
                </div>
            </div>
        </div>
        <div class="container-handle">
            <a href="javascript:void(0);"
               @click="downloadHandle">{{ $t('downAppPrize') }}</a>
        </div>
    </div>
</template>

<script>
import { createPlatformCode, merchantLotteryResult, queryNowActivity } from "@/api";
import { mapMutations, mapState } from "vuex";

export default {
    name: "Winning",
    // 组件
    components: {},
    props: {},
    data () {
        return {
            activityId: '',
            lotteryResult: '',   // 抽奖结果 100 不存在   101 未开奖   102 未中奖   103 已中奖  104 已使用
            count: 3,
            timer: null
        };
    },
    // 计算属性
    computed: {
        ...mapState(['lotteryCode']),
    },
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        ...mapMutations(['saveActivityId']),
        // 查询当前活动
        getNowActivity () {
            return new Promise((resolve, reject) => {
                queryNowActivity().then(res => {
                    if (Number(res.code) === 20000) {
                        if (res.data) {
                            this.activityId = res.data.id
                            // 保存活动ID
                            this.saveActivityId(res.data.id)
                        }
                        resolve(true)
                    } else {
                        this.$toast.fail(res.msg);
                        resolve(true)
                    }
                }).catch(err => {
                    this.$toast.fail(err);
                    resolve(true)
                })
            })
        },
        // 查询抽奖结果
        getLotteryResult () {
            return new Promise((resolve, reject) => {
                let params = {
                    code: this.lotteryCode
                }
                merchantLotteryResult(params).then(res => {
                    if (Number(res.code) === 20000) {
                        // status  100 不存在   101 未开奖   102 未中奖   103 已中奖
                        // lotteryResult   100 不存在   101 未开奖  102 未中奖    103 已中奖    104 已使用
                        // bound   抽奖码是否被使用
                        switch (res.data.status) {
                            case 100:
                                this.lotteryResult = 100
                                break;
                            case 101:
                                if (!res.data.bound) {
                                    this.lotteryResult = 101
                                } else {
                                    this.lotteryResult = 104
                                }
                                break;
                            case 102:
                                if (!res.data.bound) {
                                    this.lotteryResult = 102
                                } else {
                                    this.lotteryResult = 104
                                }
                                break;
                            case 103:
                                if (!res.data.bound) {
                                    this.lotteryResult = 103
                                } else {
                                    this.lotteryResult = 104
                                }
                                break;
                        }
                        resolve(true)
                    } else {
                        this.$toast.fail(res.msg);
                        reject(false)
                    }
                }).catch(err => {
                    this.$toast.fail(err);
                    reject(false)
                })
            })
        
        },
        // 生成平台抽奖码
        createLotteryCode () {
            if (!this.activityId) return ''
            let params = {
                activityId: this.activityId
            }
            createPlatformCode(params).then(res => {
                if (Number(res.code) === 20000) {
                    console.log('create')
                }
            })
        },
        

        // 跳转倒计时
        startTimer () {
            this.timer = setInterval(() => {
                this.count--
                if (this.count <= 0) {
                    clearInterval(this.timer)
                    // 跳转我的抽奖
                    this.$router.push({ path: '/my-lottery' })
                }
            }, 1000)
        },
        // 下载
        downloadHandle () {
            // 判断手机系统
            let userAgent = navigator.userAgent
            if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
                window.location.href = `laidan://?code=${this.lotteryCode}`
                setTimeout(() => {
                    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                    if (typeof hidden == 'undefined' || hidden === false) {
                        //App store下载地址
                        this.$copyText(this.code).then(
                            () => {
                                window.location.href = "https://apps.apple.com/cn/app/laidan/id1545081312";
                            },
                            () => {
                                window.location.href = "https://apps.apple.com/cn/app/laidan/id1545081312";
                            }
                        )
                    }
                }, 3000);
            } else if (userAgent.includes('Android')) {
                window.location.href = `laidan://?code=${this.code}`
                setTimeout(() => {
                    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                    if (typeof hidden == 'undefined' || hidden === false) {
                        //App store下载地址
                        this.$copyText(this.code).then(
                            () => {
                                window.location.href = "https://play.google.com/store/apps/details?id=com.pointsme.laidan";
                            },
                            () => {
                                window.location.href = "https://play.google.com/store/apps/details?id=com.pointsme.laidan";
                            }
                        )
                    }
                }, 2000);
            }
        }
    },
    // 创建完成
    created () {
    },
    // 挂载完成
    mounted () {
        Promise
            .all([this.getNowActivity(), this.getLotteryResult()])
            .then(() => {
                if (this.activityId && (this.lotteryResult === 102 || this.lotteryResult === 103)) {
                    this.createLotteryCode()
                }
                // 开启定时器
                this.startTimer()
            }).catch(() => {
                console.log('err')
            })
    },
    // 销毁之前
    beforeDestroy () {
        if (this.timer) {
            clearInterval(this.timer)
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    background: linear-gradient(
        180deg,
        rgba(236, 96, 42, 0.2) 0%,
        rgba(236, 138, 53, 0.2) 100%
    );
    position: relative;
    padding-top: 52px;
    padding-bottom: 110px;
    .container-header {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        height: 52px;
        padding-left: 24px;
        padding-right: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #ffffff;
        box-shadow: 0 3px 6px 1px rgba(0, 0, 0, 0.16);
        img {
            height: 24px;
        }
        a {
            display: flex;
            height: 24px;
            padding-left: 16px;
            padding-right: 16px;
            justify-content: center;
            align-items: center;
            color: #ffffff;
            font-size: 12px;
            //background-image: url("../assets/images/mini_btn_bg.png");
            //background-size: 100% 100%;
            background: linear-gradient(90deg, #ec5e29 0%, #ee8d35 100%);
            border-radius: 12px;
        }
    }
    .container-main {
        width: 100%;
        height: 100%;
        padding-left: 48px;
        padding-right: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        .card {
            width: 100%;
            min-height: 180px;
            padding: 24px;
            border-radius: 20px;
            background-color: #fff;
            box-shadow: 0 3px 6px 1px rgba(0, 0, 0, 0.16);
            .picture {
                width: 100%;
                display: flex;
                justify-content: center;
                .succeed {
                    height: 84px;
                }
            }
            .desc {
                margin-top: 18px;
                .desc-title {
                    text-align: center;
                    font-size: 15px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 600;
                    color: #ee8d35;
                    line-height: 22px;
                }
                .desc-text {
                    text-align: center;
                    font-size: 10px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    color: rgba(60, 60, 67, 0.6);
                    line-height: 16px;
                }
            }
        }
    }
    .container-handle {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 64px;
        display: flex;
        justify-content: center;
        a {
            padding-left: 24px;
            padding-right: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 200px;
            height: 40px;
            font-size: 13px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
            //background-image: url("../assets/images/btn_bg.png");
            //background-size: 100% 100%;
            background: linear-gradient(90deg, #ec5e29 0%, #ee8d35 100%);
            border-radius: 20px;
        }
    }
}
</style>
